export function LoadingScreen({ message = "正在加载数据…" }: { message?: string }): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-100 text-slate-700">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-slate-300 border-t-brand" />
      <p className="text-sm font-medium tracking-wide">{message}</p>
    </div>
  );
}
